import { PayloadRequest } from 'types/requestTypes'
import { omdApi } from '../../api'

import { TransportOverRateItem, TransportOverRateItemCreate } from '../types';

const TransportOverRate = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getTransportOverRate: builder.query<TransportOverRateItem, PayloadRequest>({
      query: () => ({
        url: `/v1/transportOverRate`,
      }),
    }),
    getTransportOverRateDetail: builder.query<TransportOverRateItemCreate, PayloadRequest>({
      query: (data) => ({
        url: `/v1/transportOverRate/${data.id}`,
      }),
    }),
    changeTransportOverRate: builder.mutation<void, TransportOverRateItemCreate>({
      query: (data) => ({
        url: `/v1/transportOverRate/${data.id}`,
        method: 'PUT',
        body: data
      }),
    }),
    createTransportOverRate: builder.mutation<void, TransportOverRateItemCreate>({
      query: (data) => ({
        url: `/v1/transportOverRate`,
        method: 'POST',
        body: data
      }),
    }),
    deleteTransportOverRate: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/transportOverRate/${data.id}`,
        method: 'DELETE',
      }),
    }),
  }),
})

export const {
  useChangeTransportOverRateMutation,
  useCreateTransportOverRateMutation,
  useGetTransportOverRateDetailQuery,
  useGetTransportOverRateQuery,
  useLazyGetTransportOverRateDetailQuery,
  useLazyGetTransportOverRateQuery,
  useDeleteTransportOverRateMutation
} = TransportOverRate
